// Define IDS spacing tokens
export type SpacingToken =
  | 'space-0' // 0px
  | 'space-2' // 2px
  | 'space-4' // 4px
  | 'space-6' // 6px
  | 'space-8' // 8px
  | 'space-10' // 10px
  | 'space-12' // 12px
  | 'space-16' // 16px
  | 'space-20' // 20px
  | 'space-24' // 24px
  | 'space-32' // 32px
  | 'space-40' // 40px
  | 'space-60'; // 60px

// Define numeric gap type for backward compatibility
export type NumericGap = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

/**
 * Maps numeric gaps to their corresponding spacing tokens.
 * This is used for backward compatibility with the old numeric gap system.
 * When the xp.mcds_redesign_spacing_components flag is enabled, numeric gaps are converted to spacing tokens.
 */
export const numericGapToSpacingToken = (gap: NumericGap): SpacingToken => {
  // Remap numeric gaps 9, 10, and 11 to 8 since larger spacing tokens are deprecating
  const effectiveGap = gap >= 9 ? 8 : gap;

  switch (effectiveGap) {
    case 0:
      return 'space-0'; // 0px
    case 1:
      return 'space-4'; // 4px
    case 2:
      return 'space-8'; // 8px
    case 3:
      return 'space-12'; // 12px
    case 4:
      return 'space-16'; // 16px
    case 5:
      return 'space-20'; // 20px
    case 6:
      return 'space-24'; // 24px
    case 7:
      return 'space-32'; // 32px
    case 8:
      return 'space-40'; // 40px
    default:
      return 'space-4'; // 4px
  }
};
